import { useCallback, useEffect, useState, useMemo } from 'react'
import {
  Alert,
  Box,
  IconButton,
  Button,
  Typography,
  FormGroup,
  FormControlLabel,
  Switch,
  Stack,
  Drawer
} from '@mui/material'
import MarkChatReadIcon from '@mui/icons-material/MarkChatRead'
import CheckIcon from '@mui/icons-material/Check'
import { useNotificationCenter } from 'react-toastify/addons/use-notification-center'

const NotificationItem = ({ notification, handleMarkAsRead }) => (
  <Alert
    severity={notification.type || 'info'}
    action={
      notification.read ? (
        <CheckIcon />
      ) : (
        <IconButton
          color='primary'
          component='span'
          onClick={handleMarkAsRead(notification.id)}
          aria-label='mark as read'
        >
          <MarkChatReadIcon />
        </IconButton>
      )
    }
  >
    {notification.content}
  </Alert>
)

export default function Notifications({ open, closeFunction, sendUnread }) {
  const { notifications, clear, markAllAsRead, markAsRead, unreadCount } = useNotificationCenter({
    filter: (item) => item.data.exclude === true
  })

  const [showUnreadOnly, setShowUnreadOnly] = useState(false)

  useEffect(() => {
    sendUnread(unreadCount)
  }, [unreadCount, sendUnread])

  const toggleFilter = () => {
    setShowUnreadOnly((prev) => !prev)
  }

  const filteredNotifications = useMemo(() => {
    return showUnreadOnly ? notifications.filter((n) => !n.read) : notifications
  }, [showUnreadOnly, notifications])

  const handleMarkAsRead = useCallback((id) => () => markAsRead(id), [markAsRead])

  const drawerHeaderSx = {
    background: '#666',
    padding: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }

  return (
    <Drawer open={open} anchor='right' onClose={closeFunction}>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={drawerHeaderSx}>
          <Typography variant='h5' color='#fff'>
            Notifications
          </Typography>
          <FormGroup sx={{ color: '#fff' }}>
            <FormControlLabel
              control={<Switch color='primary' checked={showUnreadOnly} onChange={toggleFilter} />}
              label='Afficher non-lues seulement'
            />
          </FormGroup>
        </Box>

        <Stack
          sx={{
            height: '100%',
            width: 'min(60ch, 100ch)',
            padding: '12px',
            background: '#f1f1f1',
            borderRadius: '8px',
            overflowY: 'auto'
          }}
          spacing={2}
        >
          {!notifications.length || (unreadCount === 0 && showUnreadOnly) ? (
            <Typography variant='h6'>Aucune notification</Typography>
          ) : (
            filteredNotifications.map((notification) => (
              <NotificationItem key={notification.id} notification={notification} handleMarkAsRead={handleMarkAsRead} />
            ))
          )}
        </Stack>

        <Box sx={drawerHeaderSx}>
          <Button variant='contained' onClick={clear}>
            Tout supprimer
          </Button>
          <Button variant='contained' onClick={markAllAsRead}>
            Marquer tout comme lu
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
}
